import React, { useEffect, useState } from "react";
import { AlertTriangle, ExternalLink, ShieldAlert } from "lucide-react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { useLang } from "../i18n";

export default function ThreatPanel() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/threats/summary").then((r) => setD(r.data)).catch(() => setD(false)); }, []);
  if (d === false) return null;
  const ntas = d?.ntas_active || [];
  return (
    <div className="ec-card p-6" data-testid="threat-panel">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-4">
        <h2 className="font-heading text-base md:text-lg font-bold text-slate-900 flex items-center gap-2"><ShieldAlert className="w-5 h-5 text-red-600" /> {t("th.title")}</h2>
        <span className="text-xs text-slate-400">{t("th.since")} {d?.since || "…"}</span>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <button onClick={() => navigate("/administracion/ntas")} className={`rounded-lg border p-4 text-left hover:shadow-sm transition-shadow ${ntas.length ? "border-red-300 bg-red-50" : "border-slate-200"}`} data-testid="threat-ntas">
          <div className="text-[10px] font-bold uppercase tracking-widest text-slate-500 flex items-center gap-1"><AlertTriangle className="w-3.5 h-3.5" /> {t("th.ntas")}</div>
          {!d ? <div className="text-sm text-slate-400 mt-1">…</div> : ntas.length === 0 ? (
            <div className="font-heading text-lg font-extrabold text-emerald-700 mt-1" data-testid="threat-ntas-none">{t("nt.none_active")}</div>
          ) : (
            <ul className="mt-2 space-y-1.5">
              {ntas.map((a) => (
                <li key={a.id} className="text-sm" data-testid="threat-ntas-item">
                  <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded mr-1.5 ${a.level === "Alert" ? "bg-red-600 text-white" : "bg-amber-100 text-amber-800"}`}>{a.level}</span>
                  <a href={a.url} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} className="font-semibold text-slate-800 hover:text-[#044CBC]">{a.title} <ExternalLink className="inline w-3 h-3" /></a>
                  <div className="text-xs text-slate-500 font-mono">{t("nt.expires")}: {a.expires || "—"}</div>
                </li>
              ))}
            </ul>
          )}
        </button>
        <button onClick={() => navigate("/administracion/cyber")} className={`rounded-lg border p-4 text-left hover:shadow-sm transition-shadow ${d?.kev_week_critical ? "border-amber-300 bg-amber-50/60" : "border-slate-200"}`} data-testid="threat-kev">
          <div className="text-[10px] font-bold uppercase tracking-widest text-slate-500">{t("th.kev")}</div>
          {!d ? <div className="text-sm text-slate-400 mt-1">…</div> : (
            <>
              <div className="flex items-end gap-4 mt-1">
                <div><div className="font-heading text-2xl font-extrabold text-red-700" data-testid="threat-kev-critical">{d.kev_week_critical}</div><div className="text-[10px] uppercase font-bold text-slate-500">{t("cy.critical")}</div></div>
                <div><div className="font-heading text-2xl font-extrabold text-slate-900" data-testid="threat-kev-total">{d.kev_week_total}</div><div className="text-[10px] uppercase font-bold text-slate-500">{t("th.total_week")}</div></div>
                <div><div className={`font-heading text-2xl font-extrabold ${d.suppliers_exposed ? "text-amber-700" : "text-slate-900"}`} data-testid="threat-suppliers">{d.suppliers_exposed}</div><div className="text-[10px] uppercase font-bold text-slate-500">{t("th.suppliers")}</div></div>
              </div>
              {d.kev_week_top.length > 0 && (
                <ul className="mt-2 space-y-0.5">
                  {d.kev_week_top.map((k) => <li key={k.cve_id} className="text-xs text-slate-700"><span className="font-mono font-bold">{k.cve_id}</span> — {k.vendor} {k.product} <span className="text-slate-400">({k.date_added})</span></li>)}
                </ul>
              )}
            </>
          )}
        </button>
      </div>
    </div>
  );
}
